/**
 * Created by work on 17/2/13.
 */
export const REFRESH_LIFE_DATA = 'REFRESH_LIFE_DATA';
export const REFRESH_LIFE_TAB = 'REFRESH_LIFE_TAB';
export const REFRESH_LIFE_EXPLAIN = 'REFRESH_LIFE_EXPLAIN';
export const REFRESH_ITEM_DATA = 'REFRESH_ITEM_DATA';
export const IN_ART_PAGE = 'IN_ART_PAGE';

export const refreshLifeData = (lifeData) => ({
  type: REFRESH_LIFE_DATA,
  lifeData
});

export const refreshLifeTab = (lifeTab) => ({
  type: REFRESH_LIFE_TAB,
  lifeTab
});

export const refreshLifeExplain = (newExplain) => ({
  type: REFRESH_LIFE_EXPLAIN,
  newExplain
});

export const refreshItemData = (itemData) => ({
  type: REFRESH_ITEM_DATA,
  itemData
});

export const inArtPage = (isIn) => ({
  type: IN_ART_PAGE,
  isIn
});


// WEBPACK FOOTER //
// ./src/actions/lifeReport.js